<script setup>
import { ref } from 'vue';
import { date } from 'quasar';

import Forms from '../forms/Forms.vue';

const basic = ref([
  {
    is: 'TSeparator',
    label: 'Basic Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Company Name',
        model: 'companyName',
      },
      {
        is: 'TInput',
        Label: 'Nature of Business',
        model: 'businessNature',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Company Registration',
        model: 'companyRegistration',
      },
      {
        is: 'TInput',
        Label: 'Contact Number',
        model: 'contactNo',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TSelect',
        Label: 'Credit Terms',
        options: ['30 Days', '45 Days', '60 Days'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'creditTerms',
      },
    ],
  },
  {
    is: 'TSeparator',
    label: 'Address Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Address',
        model: 'address',
      },
      {
        is: 'TSelect',
        Label: 'Country',
        options: ['Malaysia'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'country',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TSelect',
        Label: 'State',
        options: ['Johor'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'state',
      },
      {
        is: 'Row',
        row: true,

        classes: 'flex gap-2',
        ui: [
          {
            class: 'w-1/2',
            is: 'TSelect',
            Label: 'City',
            options: ['Skudai'],
            useInput: true,
            icon: 'keyboard_arrow_down',
            model: 'city',
          },
          {
            class: 'w-1/2',
            is: 'TInput',
            Label: 'Postal Code',
            model: 'postcode',
          },
        ],
      },
    ],
  },
]);

const finance = ref([
  {
    is: 'TSeparator',
    label: 'Finance Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Full Name',
        model: 'fullname',
      },
      {
        is: 'TInput',
        Label: 'Mobile No',
        model: 'mobileNo',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'E-mail',
        model: 'email',
      },
    ],
  },
  { is: 'TSeparator', label: 'Bank Details' },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Bank Name',
        model: 'bankName',
      },
      {
        is: 'TInput',
        Label: 'Branch',
        model: 'branch',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Account No',
        model: 'accountNo',
      },
      {
        is: 'Row',
        ui: [
          {
            is: 'TInput',
            Label: 'Account Name',
            model: 'accountName',
          },
          {
            is: 'TInput',
            Label: 'Swift Code',
            model: 'swiftCode',
          },
        ],
      },
    ],
  },
  { is: 'TSeparator', label: 'Uploads' },
]);

const model = ref({
  customer: null,
  subCustomer: null,
  orderType: 'Shipment',
  deliveryType: null,
  tripType: 'Drop Delivery',
  quantity: 1,
  refNo: '0123456789',
  date: date.formatDate(Date.now(), 'YYYY/MM/DD'),
  time: date.formatDate(Date.now(), 'HH:mm'),
  manPower: null,
  manPowerCharges: null,
  truckType: 'Box',
  truckSize: '1 Ton Truck',
});
const mode = ref('pickup');
</script>
<template>
  <div class="fit flex overflow-auto p-8">
    <div class="bg- w-full lg:w-1/2 flex flex-col gap-4 px-2">
      <div class="text-xl font-semibold text-primary">
        {{ $attrs.selected }}
      </div>

      <Forms :ui="basic" @input="(v, m) => (model[m] = v)" :vmodel="model" />
      <!-- <q-separator spaced class="my-8" /> -->
    </div>
    <div class="bg- w-full lg:w-1/2 flex flex-col gap-4 px-2">
      <div class="text-xl font-semibold text-primary opacity-0">
        {{ $attrs.selected }}
      </div>
      <Forms :ui="finance" @input="(v, m) => (model[m] = v)" :vmodel="model" />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
